import { InjectionToken } from '@angular/core';

export const NOTIFICATION_DISABLED = new InjectionToken<boolean>(
  'NotificationDisabled',
);
